import { render, staticRenderFns } from "./calculations.vue?vue&type=template&id=53ed7f4a&scoped=true&lang=pug&"
import script from "./calculations.vue?vue&type=script&lang=js&"
export * from "./calculations.vue?vue&type=script&lang=js&"
import style0 from "./calculations.vue?vue&type=style&index=0&id=53ed7f4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed7f4a",
  null
  
)

/* custom blocks */
import block0 from "@/lang/products/broadband?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230921151340%2Fcomponents%2Fproducts%2Fbroadband%2Fresult%2Fcalculations.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsBroadbandCostDetail: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/products/broadband/cost-detail.vue').default})
